import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from 'app/shared/util/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';

import { IPatientCaseRejectionReasonAmbulance, defaultValue } from 'app/shared/model/patient-case-rr-ambulance.model';

export const ACTION_TYPES = {
  FETCH_PATIENT_CASE_RR_AMBULANCE_LIST: 'patientCaseRrAmbulance/FETCH_PATIENT_CASE_RR_AMBULANCE_LIST',
  FETCH_PATIENT_CASE_RR_AMBULANCE: 'patientCaseRrAmbulance/FETCH_PATIENT_CASE_RR_AMBULANCE',
  FETCH_PATIENT_CASE_RR_AMBULANCE_BY_PATIENT_CASE: 'patientCaseRrAmbulance/FETCH_PATIENT_CASE_RR_AMBULANCE_BY_PATIENT_CASE',
  FETCH_PATIENT_CASE_RR_AMBULANCE_BY_AMBULANCE: 'patientCaseRrAmbulance/FETCH_PATIENT_CASE_RR_AMBULANCE_BY_AMBULANCE',
  FETCH_PATIENT_CASE_RR_AMBULANCE_BY_RR_AMBULANCE: 'patientCaseRrAmbulance/FETCH_PATIENT_CASE_RR_AMBULANCE_BY_RR_AMBULANCE',
  CREATE_PATIENT_CASE_RR_AMBULANCE: 'patientCaseRrAmbulance/CREATE_PATIENT_CASE_RR_AMBULANCE',
  UPDATE_PATIENT_CASE_RR_AMBULANCE: 'patientCaseRrAmbulance/UPDATE_PATIENT_CASE_RR_AMBULANCE',
  DELETE_PATIENT_CASE_RR_AMBULANCE: 'patientCaseRrAmbulance/DELETE_PATIENT_CASE_RR_AMBULANCE',
  RESET: 'patientCaseRrAmbulance/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IPatientCaseRejectionReasonAmbulance>,
  entity: defaultValue,
  updating: false,
  updateSuccess: false,
};

export type PatientCaseRRAmbulanceState = Readonly<typeof initialState>;

// Reducer

export default (state: PatientCaseRRAmbulanceState = initialState, action): PatientCaseRRAmbulanceState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_PATIENT_CASE):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_AMBULANCE):
    case REQUEST(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_RR_AMBULANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_PATIENT_CASE_RR_AMBULANCE):
    case REQUEST(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_AMBULANCE):
    case REQUEST(ACTION_TYPES.DELETE_PATIENT_CASE_RR_AMBULANCE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_PATIENT_CASE):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_AMBULANCE):
    case FAILURE(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_RR_AMBULANCE):
    case FAILURE(ACTION_TYPES.CREATE_PATIENT_CASE_RR_AMBULANCE):
    case FAILURE(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_AMBULANCE):
    case FAILURE(ACTION_TYPES.DELETE_PATIENT_CASE_RR_AMBULANCE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_LIST):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_PATIENT_CASE):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_AMBULANCE):
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_RR_AMBULANCE):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_PATIENT_CASE_RR_AMBULANCE):
    case SUCCESS(ACTION_TYPES.UPDATE_PATIENT_CASE_RR_AMBULANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_PATIENT_CASE_RR_AMBULANCE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/patient-case-rejection-reason-ambulance';

// Actions

export const getEntities: ICrudGetAllAction<IPatientCaseRejectionReasonAmbulance> = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_LIST,
  payload: axios.get<IPatientCaseRejectionReasonAmbulance>(`${apiUrl}?cacheBuster=${new Date().getTime()}`),
});

export const getEntity = (patientCaseId: string, ambulanceId: string) => {
  const requestUrl = `${apiUrl}/${patientCaseId}/${ambulanceId}`;
  return {
    type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE,
    payload: axios.get<IPatientCaseRejectionReasonAmbulance>(requestUrl),
  };
};

export const getEntitiesByPatientCase = (patientCaseId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_PATIENT_CASE,
  payload: axios.get<IPatientCaseRejectionReasonAmbulance>(`${apiUrl}/by-patient-case/${patientCaseId}?cacheBuster=${new Date().getTime()}`),
});

export const getEntitiesByAmbulance = (ambulanceId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_AMBULANCE,
  payload: axios.get<IPatientCaseRejectionReasonAmbulance>(`${apiUrl}/by-ambulance/${ambulanceId}?cacheBuster=${new Date().getTime()}`),
});

export const getEntitiesByRrAmbulance = (rrAmbulanceId: string) => ({
  type: ACTION_TYPES.FETCH_PATIENT_CASE_RR_AMBULANCE_BY_RR_AMBULANCE,
  payload: axios.get<IPatientCaseRejectionReasonAmbulance>(`${apiUrl}/by-rejection-reason-ambulance/${rrAmbulanceId}?cacheBuster=${new Date().getTime()}`),
});

export const createEntity: ICrudPutAction<IPatientCaseRejectionReasonAmbulance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_PATIENT_CASE_RR_AMBULANCE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const updateEntity: ICrudPutAction<IPatientCaseRejectionReasonAmbulance> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_PATIENT_CASE_RR_AMBULANCE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity = (patientCaseId: string, ambulanceId: string) => async dispatch => {
  const requestUrl = `${apiUrl}/${patientCaseId}/${ambulanceId}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_PATIENT_CASE_RR_AMBULANCE,
    payload: axios.delete(requestUrl),
  });
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
